module.exports = __webpack_public_path__ + "img/defaultpage.8b3e1048.png";